/*
* Own util plugin, to provide global method
* @author Chao
* */
const siteUtil = {
  // The install method is all that needs to exist on the plugin object.
  // It takes the global Vue object as well as user-defined options.
  install (Vue, options) {
    /*
    * Get notification from backend
    * Set notification in vuex store
    * Get will show notification and then show them on page
    * Will call this when route change (in App.vue)
    * @author Chao
    * */
    Vue.prototype.$checkNotify = function (force = false) {
//       this.$store.commit('CLEAR_NOTIFICATION')
//       // only show campaign create notification on campaign list page
//       if (this.$route.path !== '/campaign/list' && this.$route.path !== '/yourcampaigns') {
//         this.$notify({
//           group: 'campaign-notification',
//           clean: true
//         })
//       }
//       /**
//        * detect message for every page
//        */
//       if (this.login || force) {
//         const self = this
//         this.$http.get('/advertiser/user/receive-notice')
//           .then(response => {
//             // eslint-disable-next-line quotes
//             // response.data = {"success": true, "data": [{"id": "asdfsadf", "type": 3, "message": "bbbbbbbbb", "action": {"id": "3bfd9469-9cd0-48b1-a5f2-d8e657eb8f8d", "type": "edit"}, "totalAmount": "49.5", "date": "2018-01-22 17: 15: 44"}, {"id": "33asdf", "type": 0, "message": "", "action": {"id": "21fa6ec5-8e23-4188-920b-423208fbeb78", "type": "edit"}, "totalAmount": "41.5", "date": "2018-01-22 16: 34: 03"}, {"id": "33asgsa", "type": 3, "message": "asfdasdf asdf asfasdfasdfa", "action": {"id": "898e0418-717a-4734-af2c-4bbbfa61fdea", "totalAmount": "48.1", "type": "edit"}, "date": "2018-01-22 16:34:02"}]}
//             // eslint-disable-next-line quotes
//             // response.data = {"success": true, "data": [{"id": "asdfsadf", "type": 3, "message": "bbbbbbbbb", "action": {"id": "21fa6ec5-8e23-4188-920b-423208fbeb78", "type": "edit"}, "date": "2018-01-22 17: 15: 44"}]}
//             if (response.data && response.data.success) {
//               if (response.data.data.length > 0) {
//                 // record notification to vuex store
//                 this.$store.commit('SET_NOTIFICATION', response.data.data)
//                 let showingNotificationIds = []
//                 let willShowNotificationIds = []
//                 if (document.querySelectorAll('.content-notification .notification-wrapper').length > 0) {
//                   Array.prototype.forEach.call(document.querySelectorAll('.content-notification .notification-wrapper'), function (el) {
//                     if (el.querySelector('.backend-error-notification') && el.querySelector('.backend-error-notification').id) {
//                       showingNotificationIds.push(el.querySelector('.backend-error-notification').id)
//                     }
//                   })
//                 }
//                 setTimeout(function () {
//                   response.data.data.forEach(function (obj) {
//                     if (obj.type && obj.type === '1' || obj.type && obj.type === '3' || obj.type && obj.type === 1 || obj.type && obj.type === 3) { // only show error message
//                       const btnUrl = '/campaign/update/' + obj.action.id
//                       willShowNotificationIds.push(obj.id)
//                       if (showingNotificationIds.indexOf(obj.id) !== -1) {
//                         // hide notification on that campaign update page
//                         if (btnUrl === self.$route.path) {
//                           if (document.getElementById(obj.id).querySelector('.notification-close')) {
//                             self.eventFire(document.getElementById(obj.id).querySelector('.notification-close'), 'click')
//                           }
//                         }
//                       } else {
//                         // const btnUrl = '/' + obj.action.target + '/' + obj.action.type + '/' + obj.action.id
//                         const btnText = 'Update Payment Method'
//                         // const btnText = obj.button
//                         if (btnUrl !== self.$route.path) {
//                           // disabled, change to popup button
//                           // self.$notify({
//                           //   group: 'content-notification',
//                           //   title: 'Attention',
//                           //   text: obj.message,
//                           //   duration: -1,
//                           //   type: {
//                           //     notificationId: obj.id,
//                           //     notificationType: 'error',
//                           //     hideClose: true,
//                           //     // textCloseBtn: 'Got it',
//                           //     linkBtn: [
//                           //       {
//                           //         url: btnUrl,
//                           //         target: '',
//                           //         btnText: btnText
//                           //       }
//                           //     ]
//                           //   }
//                           // })
//                           self.$notify({
//                             group: 'content-notification',
//                             title: 'Attention',
//                             text: obj.message,
//                             duration: -1,
//                             type: {
//                               notificationId: obj.id,
//                               notificationType: 'error',
//                               hideClose: true,
//                               popupBtn: [
//                                 {
//                                   popupType: 'payment',
//                                   data: {
//                                     campaignId: obj.action.id, // passing campaign id
//                                     title: 'Update Payment Method',
//                                     requestUrl: '',
//                                     totalAmount: obj.totalAmount ? obj.totalAmount : '',
//                                     userPaymentId: obj.userPaymentId ? obj.userPaymentId : ''
//                                   },
//                                   btnText: btnText
//                                 }
//                               ]
//                             }
//                           })
//                         }
// //                          if (btnUrl === self.$route.path) {
// //                            if (document.getElementById(obj.id).querySelector('.notification-close')) {
// //                              self.eventFire(document.getElementById(obj.id).querySelector('.notification-close'), 'click')
// //                            }
// //                          }
//                       }
//                     }
//                   })
//                   showingNotificationIds.forEach(function (showingId) {
//                     if (willShowNotificationIds.indexOf(showingId) !== -1) {
//                     } else {
//                       if (document.getElementById(showingId).querySelector('.notification-close')) {
//                         self.eventFire(document.getElementById(showingId).querySelector('.notification-close'), 'click')
//                       }
//                     }
//                   })
//                 }, 300)
//               } else {
//                 self.$notify({
//                   group: 'content-notification',
//                   clean: true,
//                   speed: 1
//                 })
//               }
//             } else {
//               self.$notify({
//                 group: 'content-notification',
//                 clean: true,
//                 speed: 1
//               })
//             }
//           })
//       }
    }
    Vue.prototype.$objectToQueryString = function (obj) {
      return Object.keys(obj).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key])).join('&')
    }
  }
}
export default siteUtil



// WEBPACK FOOTER //
// ./src/plugins/siteUtil.js